// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__FJXR9","blink":"DotDotDot_blink__AgpVz"};